module.exports = __webpack_public_path__ + "img/remote.dc76891e.svg";